export const getSettingFromList = (list = [], userId) => {
  return list.find(item => userId === item.userId)
}